module.exports = __webpack_public_path__ + "img/jingdezhen.9ebcfa75.png";